import React from "react";
import { Carousel } from "antd";
import {
    SearchOutlined,
    TrophyOutlined,
    BellOutlined,
    TeamOutlined,
    LeftOutlined,
    RightOutlined,
} from "@ant-design/icons";
import Reveal from "../../../../components/Reveal";
import { useTranslation } from "../../../../i18n/LanguageContext";
import discoverScreen from "../../../../Vectors/appScreens/discover.webp";
import progressScreen from "../../../../Vectors/appScreens/progress.webp";
import notifyScreen from "../../../../Vectors/appScreens/notify.webp";
import communityScreen from "../../../../Vectors/appScreens/community.webp";
import "./style.css";

// Each feature drives one carousel slide. `screenshot` is a real app screen
// rendered inside the phone; without one the mock screen is shown instead.
// Title / text / screen-title strings come from the translation file.
const features = [
    { key: "discover", icon: <SearchOutlined />, screenshot: discoverScreen },
    { key: "progress", icon: <TrophyOutlined />, screenshot: progressScreen },
    { key: "notify", icon: <BellOutlined />, screenshot: notifyScreen },
    { key: "community", icon: <TeamOutlined />, screenshot: communityScreen },
];

// Custom arrows so we control the markup and centering. react-slick injects
// className/style/onClick (plus currentSlide/slideCount, which we drop so they
// don't leak onto the DOM node).
const Arrow = ({ className, style, onClick, label, children }) => (
    <button
        type="button"
        className={className}
        style={style}
        onClick={onClick}
        aria-label={label}
    >
        {children}
    </button>
);

const PhoneMockup = ({ feature, t }) => {
    const screenTitle = t(`features.${feature.key}.screen`);
    return (
        <div className="feature-phone">
            {/* Side buttons + Dynamic Island of the current iPhone design */}
            <span className="feature-phone__btn is-silent" aria-hidden="true" />
            <span className="feature-phone__btn is-volup" aria-hidden="true" />
            <span className="feature-phone__btn is-voldown" aria-hidden="true" />
            <span className="feature-phone__btn is-power" aria-hidden="true" />
            <div className="feature-phone__island" aria-hidden="true" />
            <div className="feature-phone__screen">
                {feature.screenshot ? (
                    <img
                        src={feature.screenshot}
                        alt={t(`features.${feature.key}.title`)}
                        loading="lazy"
                    />
                ) : (
                    <div className="feature-screen-mock">
                        <div className="feature-screen-mock__bar">
                            <span>{screenTitle}</span>
                        </div>
                        <div className="feature-screen-mock__icon">
                            {feature.icon}
                        </div>
                        <div className="feature-screen-mock__lines">
                            <i />
                            <i className="short" />
                            <i />
                        </div>
                        <div className="feature-screen-mock__chip">
                            {screenTitle}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const FeaturesCarousel = () => {
    const { t } = useTranslation();
    return (
        <div className="changed-background features-carousel-bg">
            <div className="main-content-wrapper">
                <section className="features-carousel" id="features">
                    <Reveal className="features-carousel__head">
                        <span className="section-eyebrow on-brand">
                            {t("features.eyebrow")}
                        </span>
                        <h2>{t("features.heading")}</h2>
                    </Reveal>

                    <Reveal className="features-carousel__body">
                        <Carousel
                            effect="fade"
                            arrows
                            dots
                            autoplay
                            autoplaySpeed={5000}
                            infinite
                            prevArrow={
                                <Arrow label="Նախորդ">
                                    <LeftOutlined />
                                </Arrow>
                            }
                            nextArrow={
                                <Arrow label="Հաջորդ">
                                    <RightOutlined />
                                </Arrow>
                            }
                        >
                            {features.map((feature) => (
                                <div key={feature.key}>
                                    <div className="feature-slide">
                                        <div className="feature-slide__visual">
                                            <PhoneMockup
                                                feature={feature}
                                                t={t}
                                            />
                                        </div>
                                        <div className="feature-slide__text">
                                            <span className="feature-slide__icon">
                                                {feature.icon}
                                            </span>
                                            <h3>
                                                {t(
                                                    `features.${feature.key}.title`
                                                )}
                                            </h3>
                                            <p>
                                                {t(
                                                    `features.${feature.key}.text`
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </Reveal>
                </section>
            </div>
        </div>
    );
};

export default FeaturesCarousel;
